__turbopack_context__.v({
  "className": "fontencodesans_d17596b0-module__TVbmpG__className",
});
